const breakfast = [
    {
        id: 1,
        name: 'English breakfast',
        description: 'smoked bacon, sausage, tomato, mushrooms, black pudding, baked beans, eggs',
        price: '14.50'
    },
    {
        id: 2,
        name: 'Avocado toast',
        description: 'poached egg, avocado, onion, tomatoes, bread',
        price: '8.50'
    },
    {
        id: 3,
        name: 'Burrito',
        description: 'tortilla, egg, cheese, potatoes, pork meat',
        price: '11.25'
    }
];

export default breakfast;